import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaTachometerAlt, FaBriefcase, FaClipboardList, FaFileAlt, FaNewspaper, FaBirthdayCake, FaChartPie, FaUserFriends, FaFileContract, FaCog, FaGlobe, FaSync, FaTrophy, FaFileInvoice, FaUserCog, FaUserTie, FaChartLine } from 'react-icons/fa';
import './SideBar.css';
import EHubImage from '../../../src/assets/app_logo.png';
import '../../colors/colors.css';
import { BiLineChart } from "react-icons/bi";
import { FaLessThan } from "react-icons/fa";
import CookiesServices from '../../services/CookiesService';

const Sidebar = ({onToggleSidebar}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [clickedPath, setClickedPath] = useState('');
  const currentYear = new Date().getFullYear();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const cookies = new CookiesServices();
  const role = cookies.get("role") || ""; 
  const [openReport, setOpenReport] = useState(false);

  const handleClick = (path) => {
    setClickedPath(path);
    if (isSmallScreen) {
      onToggleSidebar();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const userRoles = role.split('|');

  const allMenus = [
    {
      id: 'nationalDash',
      label: 'National Dashboard',
      icon: <FaGlobe />,
      path: '/nationalDashboard',
      roles: ['SUPER_ADMIN', 'CEO'],
    },
    {
      id: 'dash',
      label: 'Agent Dashboard',
      icon: <FaTachometerAlt />,
      path: '/dashboard',
      roles: ['SUPER_ADMIN', 'LOCATION_HEAD', 'TEAM_LEADER', 'FINANCE_PLANNER', 'CEO', 'QA'],
    },
    {
      id: 'ePolicy',
      label: 'ePolicy',
      icon: <FaFileAlt />,
      paths: ['/ePolicySummary'],
      roles: ['SUPER_ADMIN','UNDERWRITER'],
    },
    {
      id: 'policyDetails',
      label: 'Policy Details',
      icon: <FaClipboardList />,
      paths: ['/policyDetails', '/policyDetails/Inquiry'],
      roles: ['SUPER_ADMIN','LOCATION_HEAD', 'TEAM_LEADER', 'FINANCE_PLANNER', 'CEO', 'QA'],
    },
    {
      id: 'datasync',
      label: 'Data Sync',
      icon: <FaSync />,
      path: '/datasync',
      roles: ['SUPER_ADMIN', 'ADMIN'],
    },
    // {
    //   id: 'leadsManagement',
    //   label: 'Leads Management',
    //   icon: <BiLineChart />,
    //   path: '/leadsManagement',
    //   roles: ['SUPER_ADMIN', 'LOCATION_HEAD', 'TEAM_LEADER', 'FINANCE_PLANNER'],
    // },
    {
      id: 'salesActivity',
      label: 'Sales Activity',
      icon: <FaChartLine />,
      path: '/salesActivity',
      roles: ['SUPER_ADMIN', 'LOCATION_HEAD', 'TEAM_LEADER', 'FINANCE_PLANNER', 'CEO', 'QA'],
    },
    {
      id: 'leaderboard',
      label: 'ANBP Leaderboard',
      icon: <FaTrophy />,
      path: '/anbpLeaderboard',
      roles: ['SUPER_ADMIN', 'LOCATION_HEAD', 'TEAM_LEADER', 'FINANCE_PLANNER', 'CEO'],
    },
    {
      id: 'report',
      label: 'Reports',
      icon: <FaFileInvoice />,
      path: '/report',
      roles: ['SUPER_ADMIN', 'LOCATION_HEAD', 'TEAM_LEADER', 'FINANCE_PLANNER', 'QA', 'CEO'],
    },
    {
      id: 'incomeStatement',
      label: 'Income Statement',
      icon: <FaFileInvoice />,
      path: '/incomeStatement',
      roles: ['SUPER_ADMIN', 'INCOME_STATEMENT'],
    },
    {
      id: 'agentDashboard',
      label: 'MDRT Dashboard',
      icon: <FaUserCog />,
      path: '/MDRTDashboard',
      roles: ['SUPER_ADMIN', 'TEAM_LEADER', 'FINANCE_PLANNER'],
    },
    {
      id: 'leaderDashboard',
      label: 'MDRT Leaderboard',
      icon: <FaUserTie />,
      path: '/MDRTLeaderboard',
      roles: ['SUPER_ADMIN', 'LOCATION_HEAD', 'TEAM_LEADER', 'CEO'],
    },
  ];

  const menuItems = allMenus.filter(menu =>
    menu.roles.some(r => userRoles.includes(r))
  );

  return (
    <div className="sidebar">
      <div className="sidebar-content">
        <div className="eHub-image">
          <img src={EHubImage} alt="EHub" className="eHub-image" />
          {isSmallScreen ? <FaLessThan className="sidebar-collapse-icon" onClick={onToggleSidebar} /> : null}
        </div>
        <ul className="sidebar-list">
          {menuItems.map((item) => {
            const paths = item.paths || [item.path];
            const isSelected = paths.some(path => currentPath.startsWith(path)); // Check if current path starts with any of the paths

            return (
              <li key={item.id}>
                {item.children ? (
                  <>
                    <div
                      className={`sidebar-button ${openReport ? 'selected' : ''}`}
                      onClick={() => setOpenReport(!openReport)}
                    >
                      {item.icon}
                      <span className="sidebar-label">{item.label}</span>
                    </div>

                    {openReport && (
                      <ul className="sidebar-submenu">
                        {item.children.map(child => (
                          <li key={child.id}>
                            <Link
                              to={child.path}
                              className={`sidebar-button ${currentPath === child.path ? 'selected' : ''
                                }`}
                              onClick={() => handleClick(child.path)}
                            >
                              <span className="sidebar-label">{child.label}</span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <Link
                    to={paths[0]}
                    className={`sidebar-button ${isSelected ? 'selected' : ''} ${clickedPath === paths[0] ? 'clicked' : ''
                      }`}
                    onClick={() => handleClick(paths[0])}
                  >
                    {item.icon}
                    <span className={`sidebar-label ${isSelected ? 'selected' : ''}`}>
                      {item.label}
                    </span>
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="version-main-wrapper">
        @ {currentYear} LOLC Life Assurance <br />
        Version {process.env.REACT_APP_VERSION} <br />
        All rights reserved
      </div>
      {/* Google Tag Manager Script */}
      <script
        dangerouslySetInnerHTML={{
          __html: `(function (w, d, s, l, i) {
                        w[l] = w[l] || [];
                        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
                        var f = d.getElementsByTagName(s)[0],
                                j = d.createElement(s),
                                dl = l != "dataLayer" ? "&l=" + l : "";
                        j.async = true;
                        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                        f.parentNode.insertBefore(j, f);
                        })(window, document, "script", "dataLayer",  "${process.env.REACT_APP_GTM_ID}");`,
        }}
      />
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GTM_ID}`}
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || [];
                function gtag() {
                  dataLayer.push(arguments);
                }
                gtag("js", new Date());
                gtag("config", "${process.env.REACT_APP_GTM_ID}");`,
        }}
      />
    </div>
  );
};

export default Sidebar;